export default {
  periodFrom: null,
  periodTo: null,

  slGroupTypes: [],
  slGroupType: null,
  slGroupItems: [],
  slGroupItem: null,
  reportingCurrencyCodes: [],

  isFetchingSlGroupTypes: false,
  isFetchingSlGroupItems: false,
  isFetchingReportingCurrencyCodes: false,
  isFetchingCountryTaxTypes: false,

  countryTaxTypes: [],
  countryTaxType: null,

  currencyCode: '',

  bookTypes: [],
  bookType: '',

  isFetchingReportData: false,
};
